/**
 * Created by user on 2017/12/12/012.
 */

export { EnumSectionCollectType } from './src/var';
import { EpubMaker } from './src';

export * from './src';

export default EpubMaker;

